export default __webpack_public_path__ + "static/media/toy_face.e9eae9dd.jpg";